import { render } from "./BulkMove2.vue?vue&type=template&id=8c9ca74e&scoped=true"
import script from "./BulkMove2.vue?vue&type=script&lang=js"
export * from "./BulkMove2.vue?vue&type=script&lang=js"

import "./BulkMove2.vue?vue&type=style&index=0&id=8c9ca74e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c9ca74e"]])

export default __exports__